export default {
  title: "403 禁止访问",
  description: "抱歉，您没有权限访问此页面。如果您认为这是一个错误，请联系您的管理员。",
  goHome: "返回首页",
  goBack: "返回上一页",
};
